// src/theme/palettes/darkPalette.js
const darkPalette = {
  mode: "dark", // Default to dark mode for black backgrounds
  contrastThreshold: 4.5, // Higher contrast for better readability
  primary: {
    main: "rgb(59, 130, 246)", // Brighter blue for better visibility on mobile
    contrastText: "rgb(255, 255, 255)", // Text on the button
  },
  secondary: {
    main: "rgb(20, 184, 166)", // Brighter teal for better visibility
    contrastText: "rgb(255, 255, 255)",
  },
  background: {
    default: "rgb(0, 0, 0)", // Ensure default background is black
    paper: "rgb(15, 23, 42)", // Slightly lighter dark for paper elements
    papersecondary: "rgb(30, 41, 59)", // Paper associated with user
  },
  text: {
    primary: "rgb(255, 255, 255)", // Default primary text
    primary2: "rgb(148, 163, 184)", // Lighter for better readability
    secondary: "rgb(226, 232, 240)", // Lighter secondary text for better contrast
    white: " rgb(255, 255, 255)",
  },
  info: {
    main: "rgb(56, 189, 248)", // Brighter for better visibility
    light: "rgb(100, 181, 246)",
    dark: "rgb(25, 118, 210)",
    contrastText: "rgb(255, 255, 255)",
  },
};

export default darkPalette;
